module.exports = __webpack_public_path__ + "static/1 (5)-a3cd3d417bbb6e371e9166ccdfd7ac2a.png";